import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";

export default function Newsletter({ source = "footer", variant = "dark" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "submitting", msg: "" });
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setStatus({ state: "success", msg: "You're on the list. Welcome." });
      setEmail("");
    } catch (err) {
      setStatus({ state: "error", msg: formatApiError(err) });
    }
  };

  return (
    <form onSubmit={submit} data-testid={`newsletter-${source}`} className="w-full">
      <div className="flex items-end gap-4 border-b hairline-strong pb-2">
        <input
          required
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          data-testid={`newsletter-input-${source}`}
          className="flex-1 bg-transparent border-0 outline-none font-body text-silver placeholder:text-silver-muted/60 text-base py-2"
        />
        <button
          type="submit"
          disabled={status.state === "submitting"}
          data-testid={`newsletter-submit-${source}`}
          className="font-overline text-silver hover:text-champagne transition-colors disabled:opacity-50 whitespace-nowrap"
        >
          {status.state === "submitting" ? "Submitting…" : "Subscribe →"}
        </button>
      </div>
      {status.state === "success" && (
        <p data-testid={`newsletter-success-${source}`} className="mt-3 font-overline text-champagne">{status.msg}</p>
      )}
      {status.state === "error" && (
        <p data-testid={`newsletter-error-${source}`} className="mt-3 font-overline text-red-300">{status.msg}</p>
      )}
    </form>
  );
}
